import { DateValue } from '../types/Survey.type';

/**
 * Render a survey date answer (`DateValue`) as display text: an estimate as
 * "N unit(s) ago", otherwise the exact string. Returns '' for an unrecognized
 * object shape (never String(value), which would emit "[object Object]").
 */
export const formatSurveyDateValue = (value: unknown): string => {
  if (!value || typeof value !== 'object') return String(value || '');
  const dv = value as DateValue;

  if (
    dv.estimate &&
    typeof dv.estimate.value === 'number' &&
    typeof dv.estimate.unit === 'string'
  ) {
    return `${dv.estimate.value} ${dv.estimate.unit}${dv.estimate.value !== 1 ? 's' : ''} ago`;
  }

  if (dv.exact) return dv.exact;

  return '';
};
